import React, { useState, useEffect, SyntheticEvent, useCallback } from 'react';

import { 
  ModelBase, 
  ReusableString
} from "@models";

import { 
  CharacterFeatureSource, 
  CharacterSheetInterface, 
  CreatureInstance, 
  SummonInstance 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import LoadingBox from "@components/input/LoadingBox";
import DisplayString from "@components/input/strings/DisplayString";
import CommonUtilities from "@utilities/common_utilities";
import { DataType, isDataType } from '@dndModels/Types';

interface Props {
  display_string: string;
  cfs?: CharacterSheetInterface | CreatureInstance | SummonInstance | CharacterFeatureSource;
  log_it?: boolean;
  // onClick?: (obj: ModelBase) => void;
  descWidth?: number;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function DisplayStringWithReplacements({
  display_string,
  cfs,
  log_it = false,
  // onClick,
  descWidth
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [display_objects, setDisplayObjects] = useState<React.ReactNode[]>([]);
  const [display_strings, setDisplayStrings] = useState<string[]>([]);
  
  // // Example usage:
  // const text = "Some text {list_of_type:users; more text {list_of_type:items; end";
  // const types = extractListTypes(text);
  // console.log(types); // Output: ['users', 'items']

  const getDisplayObjects = useCallback((use_string: string) => {
    const responses: React.ReactNode[] = [];
    let key = 0;
    if (log_it) {
      debugger;
    }
    while (use_string.includes("[Replacer:")) {
      let index = use_string.indexOf("[Replacer:");
      const before = use_string.substring(0, index);
      if (before.length > 0) {
        responses.push(<div key={key++}>{ getDisplayObjects(before) }</div>); // put the before stuff into responses 
        responses.push(<div key={key++}>&nbsp;</div>);
      }
      const after = use_string.substring(index + 10);
      index = after.indexOf("]");
      use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
      const stuff = after.substring(0, index);
      index = stuff.indexOf(";");
      const data_type = stuff.substring(0, index);
      index = stuff.indexOf("(");
      const name_stuff = stuff.substring(index + 1);
      index = name_stuff.indexOf(")");
      const address_str = name_stuff.substring(0, index);
      const address = address_str.split(",");
      try {
        if (api.smart_hash[data_type]) {
          const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
          if (obj2 instanceof ReusableString) {
            responses.push(
              <div key={key++}>
                <div className="header">{obj2.label}</div><div>&nbsp;</div>
                <div>{ getDisplayObjects(obj2.content) }</div><div>&nbsp;</div>
              </div>
            );
          } else if (obj2 instanceof ModelBase) {
            responses.push(
              <div key={key++}>
                <div className="header">{obj2.use_name}</div><div>&nbsp;</div>
                <div>{ getDisplayObjects(obj2.description) }</div><div>&nbsp;</div>
              </div>
            );
          }
        }
      } catch (ex) {}
    }
    while (use_string.includes("[Modal:") || use_string.includes("[Link:")) {
      const modal_index = use_string.indexOf("[Modal:");
      const link_index = use_string.indexOf("[Modal:");
      let index = modal_index === -1 || modal_index > link_index ? link_index : modal_index;
      const before = use_string.substring(0, index);
      if (before.length > 0) {
        responses.push(<DisplayString key={key++} str={char_util.getStringWithReplacements2({ clean_me: before, obj: cfs })} />); // put the before stuff into responses 
        if (before.endsWith(" ")) {
          responses.push(<span key={key++}>&nbsp;</span>);
        } else if (before.endsWith("\n")) {
          responses.push(<br key={key++}/>);
          responses.push(<br key={key++}/>);
        }
      }
      if (index === modal_index) {
        const after = use_string.substring(index + 7);
        index = after.indexOf("]");
        const stuff = after.substring(0, index);
        use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
        index = stuff.indexOf(";");
        const data_type = stuff.substring(0, index);
        let name_stuff = stuff.substring(index + 1);
        index = name_stuff.indexOf("(");
        const name = name_stuff.substring(0, index);
        name_stuff = name_stuff.substring(index + 1);
        index = name_stuff.indexOf(")");
        const address_str = name_stuff.substring(0, index);
        const address = address_str.split(",");
        try {
          if (isDataType(data_type)) {
            if (api.smart_hash[data_type]) {
              const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
              if (obj2 instanceof ModelBase) {
                responses.push(
                  <a key={key++} className="modal_link" 
                    href={`/dandd/${data_type}/edit/${address_str}`} target="_blank" rel="noopener noreferrer"
                    onClick={(e: SyntheticEvent) => {
                      linkClicked(data_type, address_str);
                      e.preventDefault();
                    }}>
                    {name}
                  </a>
                ); // add the link 
                // use_string = common_util.replaceAll(use_string, `[Modal:${stuff}]`, `<a onclick="modalLinkClicked(${data_type},${address_str})" class="modal_link">${obj2.name}</a>`);
              } else {
                responses.push(<span key={key++}>VALUE NOT FOUND!</span>); // add the error message 
                // use_string = common_util.replaceAll(use_string, `[Modal:${stuff}]`, "VALUE NOT FOUND!");
              }
              if (use_string.startsWith(" ")) {
                responses.push(<span key={key++}>&nbsp;</span>);
              } else if (use_string.startsWith("\n")) {
                responses.push(<br key={key++}/>);
                responses.push(<br key={key++}/>);
              }
            }
          }
        } catch (ex) {}
      } else {
        const after = use_string.substring(index + 6);
        index = after.indexOf("]");
        const stuff = after.substring(0, index);
        use_string = after.substring(index + 1); // trim use_string down to just the things after this for next go round
        index = stuff.indexOf(";");
        const data_type = stuff.substring(0, index);
        let name_stuff = stuff.substring(index + 1);
        index = name_stuff.indexOf("(");
        const name = name_stuff.substring(0, index);
        name_stuff = name_stuff.substring(index + 1);
        index = name_stuff.indexOf(")");
        const address_str = name_stuff.substring(0, index);
        const address = address_str.split(",");
        try {
          if (api.smart_hash[data_type]) {
            const obj2 = api.smart_hash[data_type].find(o => address.includes(o._id));
            if (obj2 instanceof ModelBase) { // target="_blank" rel="noopener noreferrer"
              responses.push(
                <a key={key++} className="new_tab_link" 
                  href={`/dandd/${data_type}/edit/${address_str}`}>
                  {name}
                </a>
              ); // add the link 
              // use_string = common_util.replaceAll(use_string, `[Link:${stuff}]`, `<a onclick="newTabLinkClicked(${data_type},${address_str})" class="new_tab_link">${obj2.name}</a>`);
            } else {
              responses.push(<span key={key++}>VALUE NOT FOUND!</span>); // add the error message 
              // use_string = common_util.replaceAll(use_string, `[Link:${stuff}]`, "VALUE NOT FOUND!");
            }
            if (use_string.startsWith(" ")) {
              responses.push(<span key={key++}>&nbsp;</span>);
            } else if (use_string.startsWith("\n")) {
              responses.push(<br key={key++}/>);
              responses.push(<br key={key++}/>);
            }
          }
        } catch (ex) {}
      }
    }
    if (use_string.length > 0) {
      responses.push(<DisplayString key={key++} str={char_util.getStringWithReplacements2({ clean_me: use_string, obj: cfs })} />); // add anything left over
    }
    return responses;
  }, [log_it, cfs]);

  const load = useCallback( async() => {
    if (log_it) {
      debugger;
    }
    if (display_string.includes("{list_of_type")) {
      let data_types = common_util.extractListTypes(display_string);
      const smart_hash_keys = Object.keys(api.smart_hash);
      const temp_hash_keys = Object.keys(api.temp_hash);
      data_types = common_util.unique_array(data_types.filter(o => !smart_hash_keys.includes(o) && !temp_hash_keys.includes(o)));
      if (data_types.length > 0) {
        setLoading(true);
        console.log(data_types);
        await api.getSetOfObjects({ data_types });
        setLoading(false);
      }
    }
    if (descWidth) {
      setDisplayStrings(char_util.getDisplayStrings(display_string, cfs));
    } else {
      setDisplayObjects(getDisplayObjects(display_string));
    }
  }, [getDisplayObjects, descWidth, display_string, cfs, log_it]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
    }
  }, [fetched, load]);

  const linkClicked = (data_type: DataType, address_str: string) => {
    // I should make this use a different control.
    // It needs to get and display the object (or section)
    // I also need to make the source_book edit page be able to take an address_str instead of just an _id
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    if (log_it) {
      debugger;
    }
    if (descWidth) {
      return (
        <div style={{ 
          width: `${descWidth}px`,
          whiteSpace: "nowrap", 
          overflow: "hidden", 
          textOverflow: "ellipsis" 
        }}>
          { display_strings.join() }
        </div>
      );
    } else {
      return (
        <div className="padded">
          { display_objects }
        </div>
      );
    }
  }
}
